import { useCallback } from 'react'

import { admin } from '../../lib/api/admin.ts'
import type { VolumeStats } from '../../lib/api/admin.ts'
import { formatCompact, formatInt } from '../../lib/format.ts'
import { useResource } from '../../lib/useResource.ts'
import { Drawer } from '../primitives/Drawer.tsx'
import { ErrorState, LoadingRow } from '../primitives/States.tsx'
import { EndpointVolumeTable } from './VolumeStatsPanel.tsx'

/**
 * O detalhe de uma empresa no console: `GET /api/admin/stats/volume?tenantId=`,
 * que traz o volume acumulado por agente (§4.8). Só a Black Ghost abre isto.
 */
export function TenantVolumeDrawer({
  tenantId,
  tenantName,
  onClose,
}: {
  tenantId: string
  tenantName: string | null
  onClose: () => void
}) {
  const fetcher = useCallback(
    (signal: AbortSignal) => admin.volumeStats({ tenantId }, signal),
    [tenantId],
  )
  const { data, error, reload } = useResource<VolumeStats>(fetcher)
  const tenantRow = data?.tenants.find((row) => row.tenant_id === tenantId) ?? null

  return (
    <Drawer
      open
      onOpenChange={(open) => !open && onClose()}
      title={tenantName ?? tenantRow?.tenant_name ?? 'Empresa'}
      meta={
        tenantRow !== null && (
          <span className="text-micro text-fg-muted" title={`${formatInt(tenantRow.events_total)} eventos`}>
            {formatInt(tenantRow.endpoints)} endpoints ·{' '}
            <span className="tnum text-fg-secondary">{formatCompact(tenantRow.events_total)}</span> eventos
          </span>
        )
      }
    >
      <div className="min-h-0 flex-1 overflow-y-auto">
        {error !== null ? (
          <div className="p-3">
            <ErrorState error={error} onRetry={reload} />
          </div>
        ) : data === null ? (
          <LoadingRow label="Carregando o volume por agente…" />
        ) : (
          <EndpointVolumeTable endpoints={data.endpoints ?? []} />
        )}
      </div>
    </Drawer>
  )
}
